import { useEffect } from 'react';

const ContentProtection = () => {
    useEffect(() => {
        // Only enable protection in production environment
        if (process.env.NODE_ENV !== 'production') {
            return;
        }

        // 1. Disable Right Click
        const handleContextMenu = (e) => {
            e.preventDefault();
            return false;
        };

        // 2. Disable Keyboard Shortcuts (Copy, Paste, Inspect)
        const handleKeyDown = (e) => {
            // Disable F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
            if (
                e.key === 'F12' ||
                (e.ctrlKey && e.shiftKey && e.key === 'I') ||
                (e.ctrlKey && e.shiftKey && e.key === 'J') ||
                (e.ctrlKey && e.key === 'U')
            ) {
                e.preventDefault();
                return false;
            }

            // Disable Copy/Cut/Paste (Optional - can be annoying for users)
            if ((e.ctrlKey && e.key === 'c') || (e.ctrlKey && e.key === 'x') || (e.ctrlKey && e.key === 'v')) {
                e.preventDefault();
                return false;
            }
        };

        // 3. Disable Drag and Drop of images/text
        const handleDragStart = (e) => {
            e.preventDefault();
            return false;
        };

        document.addEventListener('contextmenu', handleContextMenu);
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('dragstart', handleDragStart);

        // 4. Add CSS to disable selection
        const style = document.createElement('style');
        style.innerHTML = `
      * {
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
      }
      /* Allow selection in inputs and textareas */
      input, textarea {
        -webkit-user-select: text;
        -ms-user-select: text;
        user-select: text;
      }
    `;
        document.head.appendChild(style);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('dragstart', handleDragStart);
            document.head.removeChild(style);
        };
    }, []);

    return null; // This component doesn't render anything visible
};

export default ContentProtection;
